import { FlexView } from '@cuemath/comps';
import { Button, Separator, Text } from '@cuemath/web-comps';
import React from 'react';
import useLogic from './ResultFailure.logic';
import LAYOUT from 'constants/layout';

const ResultFailure = () => {
  const { handleClose } = useLogic();

  return (
    <FlexView>
      <FlexView gutter={LAYOUT.GUTTER * 2}>
        <Text variant="body1Regular" align="center">
          Oops! We couldn't find a right match for your search!
        </Text>
      </FlexView>
      <Separator height={LAYOUT.GUTTER * 2} />
      <FlexView alignItems="center">
        <Button size="small" label="Close" onClick={handleClose} />
      </FlexView>
    </FlexView>
  );
};
export default ResultFailure;
